import  {baseActions}  from "./base.actions";

export const certrequestserviceActions = {
    add,
    edit,
    gets,
    get,
    delete: _delete
};

function add(obj,func=null) {
    
    return baseActions.add(obj,'certificationrequestservice',null,func)
}

function edit(obj,id,func=null) {
    return baseActions.edit(obj,'certificationrequestservice',id,null,func);
}

function gets( page, perPage, sortField, sortOrder,filter) {
    return baseActions.gets('certificationrequestservice', page, perPage, sortField, sortOrder,filter);
}

function get(id)
{
    return baseActions.get('certificationrequestservice',id);
}

function _delete(id,func=null)
{
    return baseActions.delete(id,'certificationrequestservice',func);
}